import React, {memo, useState} from 'react';
import PropTypes from 'prop-types';
import styles from './quiz-button.module.scss';
import {ButtonGroup, Button} from 'react-bootstrap';
import CgIcon from '@/components/atoms/cg-icon';
import QuizSection from '@/components/organisms/quiz-section';

const QuizButtonComponent = ({ points, className, quizUuid, articleTitle, collection, completed }) => {
    const [showQuiz, setShowQuiz] = useState(false);

    const handleButtonClick = () => {
        setShowQuiz(true);
    };

    return (
        <>
            <ButtonGroup
                className={!className ? styles.cgQuizButton : className}
                aria-label="Basic example"
                onClick={handleButtonClick}
            >
                <Button className={`${styles.cgQuizButton__points} ${completed ? styles.cgQuizButton__points__completed : ''}`}>★ +{points}</Button>
                <Button size={'lg'} className={`${styles.cgQuizButton__button} ${completed ? styles.cgQuizButton__button__completed : ''}`}>
                    Take the Quiz!
                </Button>
                <Button className={`${styles.cgQuizButton__pointer} ${completed ? styles.cgQuizButton__pointer__completed : ''}`}>
                    <CgIcon iconName="IoIosArrowForward" className={`${styles.cgQuizButton__forward} ${completed ? styles.cgQuizButton__forward__completed : ''}`} />
                </Button>
            </ButtonGroup>
            <QuizSection
                isOpen={showQuiz}
                onClose={() => {
                    setShowQuiz(false);
                }}
                quizUuid={quizUuid}
                articleTitle={articleTitle}
                collection={collection}
            />

        </>
    );
};

QuizButtonComponent.propTypes = {
    points: PropTypes.number,
    className: PropTypes.string,
    articleTitle: PropTypes.string,
    quizUuid: PropTypes.string,
    collection: PropTypes.string,
    completed: PropTypes.bool,
};

export default memo(QuizButtonComponent);
